export default "__VITE_ASSET__BJULm0hf__"